import { useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import { gradeSchema } from "./schema";
import { fetchGradeData } from "./read";
import { useUpdateGrade } from "../update/mutation";
import { useCreateGrade } from "../create/mutation";
import slugify from "slugify";
import { useEffect } from "react";

export const useGradeForm = ({ gradeId }) => {
  const form = useForm({
    resolver: zodResolver(gradeSchema),
    defaultValues: {
      name: "",
    },
  });

  const name = form.watch("name");
  
    // useEffect(() => {
    //   if (!gradeId) {
    //       if (name) {
    //         const slug = slugify(name, { lower: true, strict: true });
    //         form.setValue("id", slug);
    //       } else {
    //         form.setValue("id", "");
    //       }
    //     }
    // }, [name, gradeId]);

  const updateGrade = useUpdateGrade();
  const createGrade = useCreateGrade();

  const handleCreate = async (context) => {
    const item = context.values;
    await createGrade.mutateAsync({ item });
  };

  const handleUpdate = async (id, context) => {
    const values = context.dirtyValues;
    await updateGrade.mutateAsync({ gradeId: id, item: values });
  };

  const handleRead = async (id) => {
    const response = await fetchGradeData({ gradeId: id });
    return response;
  };

  return {
    form,
    handleCreate,
    handleUpdate,
    handleRead,
  };
};
